import { jsx as _jsx } from "react/jsx-runtime";
import { startCase } from "lodash";
import { Label } from "@fluentui/react";
import "./CustomerSearch.css";
import { SearchType } from "../../models";
const CustomerSearchResult = ({ customerData, partnerData, searchType, hideEmptyFields, hideSalesId, }) => {
    const keyValuePairs = Object.entries(searchType === SearchType.Customer
        ? customerData
        : partnerData !== null && partnerData !== void 0 ? partnerData : {})
        .filter(([key, value]) => {
        if (hideSalesId && key.toLowerCase() === "mssalesid") {
            return false;
        }
        return (!hideEmptyFields ||
            (value !== undefined && value !== null && String(value).trim() !== ""));
    })
        .map(([key, value]) => `${startCase(key)}:${value}`);
    const rowContent = keyValuePairs.join(" | ");
    return _jsx(Label, Object.assign({ className: "searchResult" }, { children: rowContent }));
};
export default CustomerSearchResult;
